export const requestHealthCard = (state) => state.requestHealthCard;
export const showRequestAcceptedDialog = (state) => state.showRequestAcceptedDialog;
export const showRequestPartiallyAcceptedDialog = (state) => state.showRequestPartiallyAcceptedDialog;
export const showRequestDeniedDialog = (state) => state.showRequestDeniedDialog;
export const digitalInsuranceCardInformation = (state) => state.digitalInsuranceCardInformation;
